import {css, styled} from '@mui/material';
import {StyledCard} from 'presentation/components/StyledCard';
import {AuthorizationCardContainerProps} from './types';

export const AuthorizationCardContainer = styled(
	StyledCard.Container,
)<AuthorizationCardContainerProps>`
	height: 100%;
	gap: 12px;
	justify-content: space-between;
	min-height: 295px;
	${({$borderColor}) =>
		$borderColor &&
		css`
			border-top: 4px solid ${$borderColor};
		`}
`;
